import { render, staticRenderFns } from "./failModal.vue?vue&type=template&id=d75395e2&"
import script from "./failModal.vue?vue&type=script&lang=js&"
export * from "./failModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports